module.exports = __webpack_public_path__ + "img/97.1440fb3d.jpg";